import { getLocaleConfig } from 'config';
import { format } from 'date-fns';
import { de } from 'date-fns/locale';
import {
  IBlogAuthorFields,
  IBlogCategoryFields,
  IBlogPostFields,
} from 'global';
import { getMagazineBathPath } from '../constants';

/** Format date for magazine */
export const formatDate = (dateString: string): string | null => {
  try {
    return format(new Date(dateString), 'dd.MM.yyyy', {
      locale: de,
    });
  } catch (error) {
    return null;
  }
};

/** Factory method for creating pagination query for Contentful*/
export const nextPageQueryFactory =
  (limit: number) =>
  (
    pageNumber: number
  ): {
    limit: number;
    skip: number;
  } => ({
    limit,
    skip: limit * (pageNumber - 1),
  });

type AuthorPathInput = {
  author: IBlogAuthorFields;
};

type MainPathInput = {
  mainCategory: IBlogCategoryFields;
};

type SubPathInput = {
  subCategory: IBlogCategoryFields;
} & MainPathInput;

type BlogPostPath = {
  blogPost: IBlogPostFields | string;
} & SubPathInput;

type MagazineFullUrlInput =
  | AuthorPathInput
  | MainPathInput
  | SubPathInput
  | BlogPostPath;

/** Generate url or path for magazine path  */
export const getMagazineUrl = (
  urlConfig?: MagazineFullUrlInput,
  /** if it's true, it returns full url domain */
  fullUrl = false,
  locale?: string
): string => {
  const urlElements: Array<string> = [];
  const { frontendUrl, shopId } = getLocaleConfig(locale);
  const magazineBathPath = getMagazineBathPath(shopId);

  if (fullUrl) {
    urlElements.push(`${frontendUrl}`);
  }
  urlElements.push(`${magazineBathPath}`);

  if (urlConfig && 'author' in urlConfig) {
    urlElements.push('author', `${urlConfig.author.handle}`);
  } else if (urlConfig && 'mainCategory' in urlConfig) {
    urlElements.push(`${urlConfig.mainCategory.handle}`);
    'subCategory' in urlConfig &&
      urlElements.push(`${urlConfig.subCategory.handle}`);
    if ('blogPost' in urlConfig) {
      if (typeof urlConfig.blogPost !== 'string') {
        urlElements.push(`${urlConfig.blogPost.handle}`);
      } else {
        urlElements.push(`${urlConfig.blogPost}`);
      }
    }
  }

  let rtnUrl = urlElements.join('/');

  // if full url is not intended, add '/' so that it's compatible to subpath
  if (!fullUrl) {
    rtnUrl = `/${rtnUrl}`;
  }

  return rtnUrl;
};
